export const MONITOR_SESSIONS_RELEASE_FILTER_KEY = "monitor.sessions";
export const MONITOR_FAILED_INTERACTIONS_RELEASE_FILTER_KEY = "monitor.failedInteractions";
export const MONITOR_REPORTS_RELEASE_FILTER_KEY = "monitor.reports";
